import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { handleInvalidToken } from "../../AuthUtils";
import AnimationSpinner from "../../AnimationSpinner";
import GetToken from "../../GetToken";
import UpGradeBox from "../../components/upgradeBox/UpGradeBox";
import TeamPremium from "../../assests/images/TEAMBUDDY OTOS MOCKUP/TEAM-PREMIUM.png"
import TeamMax from "../../assests/images/TEAMBUDDY OTOS MOCKUP/TEAM-MAX.png"
import TeamMembership from "../../assests/images/TEAMBUDDY OTOS MOCKUP/TEAM-MEMBERSHIP.png"
import TeamDfy from "../../assests/images/TEAMBUDDY OTOS MOCKUP/TEAM-DFY.png"
import TeambuddyAi from "../../assests/images/TEAMBUDDY OTOS MOCKUP/TEAM-FRONTEND.png"
import TeamEbook from "../../assests/images/TEAMBUDDY OTOS MOCKUP/TEAM-EBOOK.png"
import TeamStore from "../../assests/images/TEAMBUDDY OTOS MOCKUP/TEAM-STORE.png"
import TeamAudiobook from "../../assests/images/TEAMBUDDY OTOS MOCKUP/TEAM-AUDIOBOOK.png"
import TeamAgency from "../../assests/images/TEAMBUDDY OTOS MOCKUP/TEAM-AGENCY.png"
import TeamReseller from "../../assests/images/TEAMBUDDY OTOS MOCKUP/TEAM-RESELLER.png"
import TeamWhiteLabel from "../../assests/images/TEAMBUDDY OTOS MOCKUP/TEAM-WHITELABEL.png"



const UpGradePage = ({ base_url }) => {
	const [userPackages, setUserPackages] = useState([]);
	// const [packages, setPackages] = useState({});
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const fetchUserPackage = async () => {
			try {
				const token = GetToken();
				if (!token) {
					handleInvalidToken();
					return;
				}
				setLoading(true);
				const formdata = new FormData();
				formdata.append("action", "fetchUserPackages");
				formdata.append("token", token);
				const response = await axios.post(
					`${base_url}api/user/get-user-resource`,
					formdata
				);
				if (response.data.status) {
					setLoading(false);
					setUserPackages(response.data.items);
				} else {
					setLoading(false);
					Swal.fire({
						icon: "error",
						title: "Error",
						text: response.data.message,
					});
				}
			} catch (error) {
				setLoading(false);
				Swal.fire({
					icon: "error",
					title: "Error",
					text:
						error.response?.data?.message ||
						error.message ||
						"Failed to insert data. Please try again.",
				});
			}
		};

		// const fetchPackageList = async () => {
		// 	try {
		// 		const token = GetToken();
		// 		if (!token) {
		// 			handleInvalidToken();
		// 			return;
		// 		}
		// 		setLoading(true);
		// 		const formdata = new FormData();
		// 		formdata.append("action", "fetchPackages");
		// 		formdata.append("token", token);
		// 		const response = await axios.post(
		// 			`${base_url}api/user/get-user-resource`,
		// 			formdata
		// 		);
		// 		if (response.data.status) {
		// 			setLoading(false);
		// 			setPackages(response.data.items);
		// 		} else {
		// 			setLoading(false);
		// 			Swal.fire({
		// 				icon: "error",
		// 				title: "Error",
		// 				text: response.data.message,
		// 			});
		// 		}
		// 	} catch (error) {
		// 		setLoading(false);
		// 		Swal.fire({
		// 			icon: "error",
		// 			title: "Error",
		// 			text:
		// 				error.response?.data?.message ||
		// 				error.message ||
		// 				"Failed to insert data. Please try again.",
		// 		});
		// 	}
		// };
		// fetchPackageList();
		fetchUserPackage();
	}, []);

	return (
		<div className="right-container">
			<AnimationSpinner show={loading} />
			<div className="content">
				<div className="container">
					<div className="row">
						<div className="col-12">
							<div className="page-title-box">
								<h4 className="page-title">Upgrade</h4>
							</div>
						</div>
					</div>
					<div className="row">
						{userPackages.includes(1) || userPackages.includes(2) ? (
							<UpGradeBox title={"CloneWeb AI Frontend"} activated={true} img={TeambuddyAi} />
						) : <UpGradeBox title={"CloneWeb AI Frontend "} activated={false} img={TeambuddyAi} upgrade={"Frontend"} url="https://getclonewebai.com" />}

						{userPackages.includes(2) ? (
							<UpGradeBox title={"CloneWeb AI Business Edition"} img={TeambuddyAi} activated={true} />
						) : null}

						{userPackages.includes(3) ? (
							<UpGradeBox title={"CloneWeb AI Premium Edition"} activated={true} img={TeamPremium} />
						) : <UpGradeBox title={"CloneWeb AI Premium Edition"} activated={false} img={TeamPremium} upgrade={"Premium"} url="https://getclonewebai.com/premium-oto1" />}
						{userPackages.includes(4) ? (
							<UpGradeBox title={"CloneWeb AI Unlimited Edition"} activated={true} img={TeamMax} />
						) : <UpGradeBox title={"CloneWeb AI Unlimited Edition"} activated={false} img={TeamMax} upgrade={"Unlimited"} url="https://getclonewebai.com/unlimited-oto2" />}
						{userPackages.includes(5) ? (
							<UpGradeBox title={"CloneWeb AI VideoClone Edition"} activated={true} img={TeamMembership} />
						) : <UpGradeBox title={"CloneWeb AI VideoClone Edition"} activated={false} img={TeamMembership} upgrade={"VideoClone"} url="https://getclonewebai.com/videoclone-oto3" />}
						{userPackages.includes(6) ? (
							<UpGradeBox title={"CloneWeb AI Ebook Edition"} activated={true} img={TeamEbook} />
						) : <UpGradeBox title={"CloneWeb AI Ebook Edition"} activated={false} img={TeamEbook} upgrade={"Ebook"} url="https://getclonewebai.com/ebook-oto4" />}
						{userPackages.includes(7) ? (
							<UpGradeBox title={"CloneWeb AI DFY Edition"} activated={true} img={TeamDfy} />
						) : <UpGradeBox title={"CloneWeb AI DFY Edition"} activated={false} img={TeamDfy} upgrade={"DFY"} url="https://getclonewebai.com/dfy-oto5" />}
						{userPackages.includes(8) ? (
							<UpGradeBox title={"CloneWeb AI Ecom Store Edition"} activated={true} img={TeamStore} />
						) : <UpGradeBox title={"CloneWeb AI Ecom Store Edition"} activated={false} img={TeamStore} upgrade={"EcomStore"} url="https://getclonewebai.com/ecomstore-oto6" />}
						{userPackages.includes(9) ? (
							<UpGradeBox title={"CloneWeb AI AudioBook Edition"} activated={true} img={TeamAudiobook} />
						) : <UpGradeBox title={"CloneWeb AI AudioBook Edition"} activated={false} img={TeamAudiobook} upgrade={"AudioBook"} url="https://getclonewebai.com/audiobook-oto7" />}
						{userPackages.includes(10) || userPackages.includes(11) ? (
							<UpGradeBox title={"CloneWeb AI Agency Edition"} activated={true} img={TeamAgency} />
						) : <UpGradeBox title={"CloneWeb AI Agency Edition"} activated={false} img={TeamAgency} upgrade={"Agency"} url="https://getclonewebai.com/agency-oto8" />}
						{userPackages.includes(12) || userPackages.includes(13) ? (
							<UpGradeBox title={"CloneWeb AI Reseller Edition"} activated={true} img={TeamReseller} />
						) : <UpGradeBox title={"CloneWeb AI Reseller Edition"} activated={false} img={TeamReseller} upgrade={"Reseller"} url="https://getclonewebai.com/reseller-oto9" />}
						{userPackages.includes(14) ? (
							<UpGradeBox title={"CloneWeb AI Whitelabel Edition"} img={TeamWhiteLabel} activated={true} />
						) : (<UpGradeBox title={"CloneWeb AI Whitelabel Edition"} img={TeamWhiteLabel} activated={false} upgrade={"Whitelabel"} url="https://getclonewebai.com/whitelabel-oto10" />)}
						{userPackages.includes(15) ? (
							<UpGradeBox title={"CloneWeb AI VIP Pack"} img={TeambuddyAi} activated={true} />
						) : null}
						{userPackages.includes(16) ? (
							<UpGradeBox title={"CloneWeb AI Automation Pack"} img={TeambuddyAi} activated={true} />
						) : null}
						{userPackages.includes(17) ? (
							<UpGradeBox title={"CloneWeb AI Unlimited Pack"} img={TeambuddyAi} activated={true} />
						) : null}
						{userPackages.includes(18) ? (
							<UpGradeBox title={"CloneWeb AI Ultimate Pack"} img={TeambuddyAi} activated={true} />
						) : null}
						{userPackages.includes(19) ? (
							<UpGradeBox title={"CloneWeb AI Ebook VIP Pack"} img={TeambuddyAi} activated={true} />
						) : null}
						{userPackages.includes(20) ? (
							<UpGradeBox title={"CloneWeb AI DFY Club"} img={TeambuddyAi} activated={true} />
						) : null}
						{userPackages.includes(21) ? (
							<UpGradeBox title={"CloneWeb AI Store Premium Pack"} img={TeambuddyAi} activated={true} />
						) : null}
						{userPackages.includes(22) ? (
							<UpGradeBox title={"CloneWeb AI Unlimited AudioBook Pack"} img={TeambuddyAi} activated={true} />
						) : null}
						{userPackages.includes(23) ? (
							<UpGradeBox title={"CloneWeb AI Agency Club"} img={TeambuddyAi} activated={true} />
						) : null}
						{userPackages.includes(24) ? (
							<UpGradeBox title={"CloneWeb AI Reseller Bundle"} img={TeambuddyAi} activated={true} />
						) : null}
						{userPackages.includes(25) ? (
							<UpGradeBox title={"CloneWeb AI Developer VIP Pack"} img={TeambuddyAi} activated={true} />
						) : null}
					</div>
				</div>
			</div>
		</div>
	);
};

export default UpGradePage;
